import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=d55d84f0&scoped=true&"
import script from "./PartnerInfo.vue?vue&type=script&lang=js&"
export * from "./PartnerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55d84f0",
  null
  
)

export default component.exports